<template>
  <div class="relative flex opacity-80 "
    v-if="
      device?.dev_family != null && (
        device?.dev_family?.dock_dev_id != undefined ||
        device?.dev_family?.rc_dev_id != undefined ||
        device?.dev_family?.drone_dev_id != undefined ||
        device?.dev_family?.parachute_dev_id != undefined
      )
    "
  >
    <div class="box !p-0 box-25 last:mr-0 relative w-full device_small">

        <template v-if="device?.dev_family?.dock_dev_id != undefined">
          <div class="flex">
            <div class="flex flex-col items-center justify-center p-2 w-[55px] min-w-[55px] max-w-[55px] bg-g2">
              <SVG name="dock" css="fill-current w-[45px]"></SVG>
            </div>

            <div class="flex w-full flex-wrap">
              <div class="px-2 py-2 w-full flex flex-col justify-around">
                <span class="text-balance">
                  #{{ device?.dev_family?.dock_dev_id }} - {{ device?.dev_family?.dock_dev_name }}
                </span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="device?.dev_family?.rc_dev_id != undefined">
          <div class="flex">
            <div class="flex flex-col items-center justify-center p-2 w-[55px] min-w-[55px] max-w-[55px] bg-g2">
              <SVG name="rc" css="fill-current w-[25px]"></SVG>
            </div>

            <div class="flex w-full flex-wrap">
              <div class="px-2 py-2 w-full flex flex-col justify-around">
                <span class="text-balance">
                  #{{ device?.dev_family?.rc_dev_id }} - {{ device?.dev_family?.rc_dev_name }}
                </span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="device?.dev_family?.drone_dev_id != undefined">
          <div class="flex border-g2 border-t">
            <div class="flex flex-col items-center justify-center p-2 w-[55px] min-w-[55px] max-w-[55px] bg-g2">
              <SVG name="drone" css="fill-current w-[21px]"></SVG>
            </div>

            <div class="flex w-full flex-wrap">
              <div class="px-2 py-2 w-full flex flex-col justify-around">
                <span class="text-balance">
                  #{{ device?.dev_family?.drone_dev_id }} - {{ device?.dev_family?.drone_name }}
                </span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="device?.dev_family?.parachute_dev_id != undefined">
          <div class="flex border-g2 border-t">
            <div class="flex flex-col items-center justify-center p-2 w-[55px] min-w-[55px] max-w-[55px] bg-g2">
              <SVG name="parachute" css="fill-current w-[21px]"></SVG>
            </div>

            <div class="flex w-full flex-wrap justify-between items-center">
              <div class="px-2 py-2 flex flex-col justify-around">
                <span class="text-balance">
                  #{{ device?.dev_family?.parachute_dev_id }} - {{ device?.dev_family?.parachute_name }}
                </span>
              </div>

              <div
                @click="fireParachute()"
                class="cursor-pointer w-[20px] h-[20px] flex items-center justify-center bg-error rounded-full mr-2"
                v-if="$root.user.can([3,4,5], 'DEVICES.FTS.fire')"
              >
                !
              </div>
            </div>
          </div>
        </template>


        <Device_Link
          v-if="
            $root.user.can([4,5], 'DEVICES.EDIT.edit_device') &&
            device?.dev_family?.this_dev_id != undefined &&
            !$root.isMilestonePlugin
          "
          :dev_id="device.dev_family.this_dev_id"
          CssClass="right-[10px] !top-[13px]"
        />
    </div>
  </div>
</template>
<script>
import SVG from "@/partials/SVG.vue";
import Device_Link from "@/partials/Device/Template/Device_Link.vue";

export default {
  name: "Device_Info_Offline",
  components: {
    SVG,
    Device_Link
  },
  props: {
    device: {
      type: Object,
      required: true
    },
  },
  setup() {
    return {
    };
  },

  mounted() {

  },

  methods: {

    async fireParachute() {
      this.$root.confirm_open({
        message: this.$e("Êtes-vous sûr de vouloir déclencher le parachute ?"),
        true: async () => {
          let data = await API.put("ftsfire", {
            DevId: this.device?.dev_family?.this_dev_id,
          });

          this.$root.msg_replie[data.command] = {
            id: data.command,
            name: this.$e("Déclenchement du parachute"),
          };
        },
        false: () => { },
      });
    },
  },
};
</script>
